import { AxiosError } from 'axios';
import { Configuration, DefaultApiFactory } from '@dazzle/api-client';

import { getAuthToken } from 'Common/util/Auth';

declare const WEBSERVER_BASE_URL: string;

export class TokenExpiredError extends Error {}

export class DazzleRPCError extends Error {
  method: string;
  statusCode?: number;

  constructor(message: string, method: string, statusCode?: number) {
    super(message);

    this.method = method;
    this.statusCode = statusCode;
  }
}

const generateApi = () => {
  const configuration = new Configuration({
    basePath: WEBSERVER_BASE_URL,
    baseOptions: {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
      withCredentials: true,
    },
  });

  return DefaultApiFactory(configuration);
};

let apiInstance = generateApi();

export const regenerateApi = () => {
  apiInstance = generateApi();
};

export const getApi = () => {
  return apiInstance;
};

const isAxiosError = (e: unknown): e is AxiosError => {
  return e instanceof Error && e.name === 'AxiosError';
};

export const handleApiError = (e: unknown, method: string, isRetry?: boolean) => {
  console.log(`[DazzleService] Error during ${method} Api ${isRetry ? 'retry' : 'call'}: ${e}`);
  if (isRetry === false) {
    return;
  }
  if (isAxiosError(e)) {
    const is401 = e.response?.status === 401;
    console.log(`[DazzleService] AxiosError: ${JSON.stringify(e.response?.data)}`);
    const data = e.response?.data as { message: string };
    if (is401) {
      throw new TokenExpiredError(data?.message ?? 'Token expired');
    } else if (data?.message) {
      throw new DazzleRPCError(data.message, method, e.response?.status);
    }
  }
  throw e;
};
